import { Box, Stack, Typography } from "@mui/material";
import useLocales from "src/hooks/useLocales";

import InfoTerms from "./InfoTerms";

// ----------------------------------------------------------------------

export const InfoTitle = () => {
	const { translate } = useLocales();

	return (
		<Stack>
			<Typography variant='subtitle1'>{translate("customization.connect_account_with")}</Typography>
			<Typography variant='h4' sx={{ mb: 1 }}>
				{"Vumi"}
			</Typography>
			<Typography variant='subtitle2' sx={{ mt: 1 }}>
				{translate("demo.this_demo")}
			</Typography>

			<Typography
				sx={{ mt: 2, mb: 2 }}
				color='text.secondary'
				fontSize={{ xs: 11, sm: 13 }}
				variant='body1'
				maxWidth={450}
			>
				{"VUMI "}
				<Box display={"inline"} fontWeight={750} color='text.primary'>
					{translate("demo.info_demo_1")}
				</Box>
				{translate("demo.info_demo_2")}
			</Typography>

			<InfoTerms />
		</Stack>
	);
};

export default InfoTitle;
